<template>
  <section class="loading">
    <div class="container">
      <div class="loading__inner">
        <div class="loader">
          <div class="loader__circle"></div>
          <div class="loader__circle"></div>
          <div class="loader__circle"></div>
        </div>
      </div>
    </div>
  </section>
</template>